import { Component, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { SetConnector, SetConnectorId } from '../../store/actions/integrations.actions';
import { Actions, ofType } from '@ngrx/effects';
import { Store } from '@ngrx/store';
import { debounceTime, Subject, takeUntil } from 'rxjs';

@Component({
    selector: 'app-connector',
    templateUrl: './connector.component.html',
    styleUrls: ['./connector.component.scss'],
    standalone: false,
})
export class ConnectorComponent implements OnInit, OnDestroy {
    private unsubscribe = new Subject<void>();

    constructor(private store$: Store, private _route: ActivatedRoute, private actions$: Actions) {}

    ngOnInit(): void {
        this._route.params.pipe(takeUntil(this.unsubscribe)).subscribe(params => {
            this.store$.dispatch(SetConnectorId({ connectorId: params?.id }));
        });
        this.actions$.pipe(ofType(SetConnector), takeUntil(this.unsubscribe), debounceTime(100)).subscribe(event => {
            event.connector?.connectorName && this.store$.dispatch(SetConnectorId({ connectorId: event.connector?.connectorName }));
        });
    }

    ngOnDestroy(): void {
        this.unsubscribe.next();
        this.unsubscribe.complete();
        this.store$.dispatch(SetConnectorId({ connectorId: undefined }));
    }
}
